/*
 * @Description: 谷仓销售管理路由模块
 * @Author: mdb
 * @Date: 2022-05-31 17:37:48
 * @LastEditTime: 2023-06-29 15:41:32
 * @LastEditors: cxh
 */
import Layout from '@/layout/index.vue'

const routerItem = {
  path: '/fbu',
  component: Layout,
  children: [
    {
      path: 'index',
      name: 'DcCosFbuIndex',
      meta: { title: '首页', noCache: true },
      component: require('@/views/gucangSales/index/index.vue').default
    },
    {
      path: 'salesClue',
      name: 'DcCosFbuSalesClue',
      meta: { title: '销售线索' },
      component: require('@/views/gucangSales/clueManage/salesClue/index.vue').default
    },
    {
      path: 'salesClue/view',
      name: 'DcCosFbuSalesClueView',
      meta: { title: '销售线索详情', noCache: true },
      component: require('@/views/gucangSales/clueManage/salesClue/view.vue').default
    },
    {
      path: 'salesClue/add',
      name: 'DcCosFbuSalesClueAdd',
      meta: { title: '添加销售线索' },
      component: require('@/views/gucangSales/clueManage/salesClue/add.vue').default
    },
    {
      path: 'salesClue/edit',
      name: 'DcCosFbuSalesClueEdit',
      meta: { title: '编辑销售线索' },
      component: require('@/views/gucangSales/clueManage/salesClue/edit.vue').default
    },
    {
      path: 'publicClue',
      name: 'DcCosFbuPublicClue',
      meta: { title: '线索公海池' },
      component: require('@/views/gucangSales/clueManage/publicClue/index.vue').default
    },
    {
      path: 'publicClue/view',
      name: 'DcCosFbuPublicClueView',
      meta: { title: '公海池详情', noCache: true },
      component: require('@/views/gucangSales/clueManage/salesClue/view.vue').default
    },
    {
      path: 'potential',
      name: 'DcCosFbuPotential',
      meta: { title: '潜在客户' },
      component: require('@/views/gucangSales/customerCenter/potential/index.vue').default
    },
    {
      path: 'potential/view',
      name: 'DcCosFbuPotentialView',
      meta: { title: '潜在客户详情', noCache: true },
      component: require('@/views/gucangSales/customerCenter/potential/view/index.vue').default
    },
    {
      path: 'potential/perfect',
      name: 'DcCosFbuPotentialPerfect',
      meta: { title: '潜在客户完善资料' },
      component: require('@/views/gucangSales/customerCenter/potential/perfect/index.vue').default
    },
    // {
    //   path: 'potential/add',
    //   name: 'DcCosFbuPotentialAdd',
    //   meta: { title: '潜在客户新增' },
    //   component: require('@/views/gucangSales/customerCenter/potential/edit/index.vue').default
    // },
    {
      path: 'potential/edit',
      name: 'DcCosFbuPotentialPerEdit',
      meta: { title: '潜在客户编辑' },
      component: require('@/views/gucangSales/customerCenter/potential/edit/index.vue').default
    },
    {
      path: 'turnToContract',
      name: 'DcCosFbuTurnToContract',
      meta: { title: '转签约' },
      component: require('@/views/gucangSales/customerCenter/turnToContract/index.vue').default
    },
    {
      path: 'customerActive',
      name: 'DcCosFbuCustomerActive',
      meta: { title: '流失激活' },
      component: require('@/views/gucangSales/customerCenter/lossToActive/index.vue').default
    },
    {
      path: 'contract',
      name: 'DcCosFbuContract',
      meta: { title: '签约客户' },
      component: require('@/views/gucangSales/customerCenter/contract/index.vue').default
    },
    {
      path: 'contract/view',
      name: 'DcCosFbuContractView',
      meta: { title: '签约客户详情', noCache: true },
      component: require('@/views/gucangSales/customerCenter/contract/view/index.vue').default
    },
    {
      path: 'contract/edit',
      name: 'DcCosFbuContractEdit',
      meta: { title: '签约客户编辑' },
      component: require('@/views/gucangSales/customerCenter/contract/edit/index.vue').default
    },
    {
      path: 'turnToDeal',
      name: 'DcCosFbuTurnToDeal',
      meta: { title: '转成交' },
      component: require('@/views/gucangSales/customerCenter/turnToDeal/index.vue').default
    },
    {
      path: 'clients',
      name: 'DcCosFbuClients',
      meta: { title: '成交客户' },
      component: require('@/views/gucangSales/customerCenter/clients/index.vue').default
    },
    {
      path: 'clients/view',
      name: 'DcCosFbuClientsView',
      meta: { title: '成交客户详情', noCache: true },
      component: require('@/views/gucangSales/customerCenter/clients/view/index.vue').default
    },
    {
      path: 'clients/edit',
      name: 'DcCosFbuClientsEdit',
      meta: { title: '成交客户编辑' },
      component: require('@/views/gucangSales/customerCenter/clients/edit/index.vue').default
    },
    {
      path: 'accountCode',
      name: 'DcCosFbuAccountCode',
      meta: { title: '客户代码' },
      component: require('@/views/gucangSales/customerCenter/accountCode/index.vue').default
    },
    {
      path: 'accountCode/view',
      name: 'DcCosFbuAccountCodeDetail',
      meta: { title: '客户代码详情', noCache: true },
      component: require('@/views/gucangSales/customerCenter/accountCode/detail/index.vue').default
    },
    {
      path: 'mainBody',
      name: 'DcCosFbuMainBody',
      meta: { title: '签约主体' },
      component: require('@/views/gucangSales/customerCenter/mainBody/index.vue').default
    },
    {
      path: 'business',
      name: 'DcCosFbuBusiness',
      meta: { title: '商机管理' },
      component: require('@/views/gucangSales/chanceManage/business/index.vue').default
    },
    {
      path: 'business/add',
      name: 'DcCosFbuBusinessAdd',
      meta: { title: '新增商机' },
      component: require('@/views/gucangSales/chanceManage/business/add.vue').default
    },
    {
      path: 'business/view',
      name: 'DcCosFbuBusinessView',
      meta: { title: '商机详情', noCache: true },
      component: require('@/views/gucangSales/chanceManage/business/view.vue').default
    },
    {
      path: 'business/edit',
      name: 'DcCosFbuBusinessEdit',
      meta: { title: '编辑商机' },
      component: require('@/views/gucangSales/chanceManage/business/edit.vue').default
    },
    {
      path: 'business/copy',
      name: 'DcCosFbuBusinessCopy',
      meta: { title: '复制商机' },
      component: require('@/views/gucangSales/chanceManage/business/copy.vue').default
    },
    {
      path: 'visitorProgram',
      name: 'DcCosFbuVisitorProgram',
      meta: { title: '访客计划' },
      component: require('@/views/gucangSales/followUpManage/visitorProgram/index.vue').default
    },
    {
      path: 'visitorProgram/add',
      name: 'DcCosFbuVisitorProgramAdd',
      meta: { title: '新增访客计划' },
      component: require('@/views/gucangSales/followUpManage/visitorProgram/add.vue').default
    },
    {
      path: 'visitorProgram/edit',
      name: 'DcCosFbuVisitorProgramEdit',
      meta: { title: '编辑访客计划' },
      component: require('@/views/gucangSales/followUpManage/visitorProgram/edit.vue').default
    },
    {
      path: 'visitorProgram/view',
      name: 'DcCosFbuVisitorProgramView',
      meta: { title: '访客计划详情', noCache: true },
      component: require('@/views/gucangSales/followUpManage/visitorProgram/view.vue').default
    },
    {
      path: 'followUpRecord',
      name: 'DcCosFbuFollowUpRecord',
      meta: { title: '跟进记录' },
      component: require('@/views/gucangSales/followUpManage/followUpRecord/index.vue').default
    },
    {
      path: 'followUpRecord/add',
      name: 'DcCosFbuFollowUpRecordAdd',
      meta: { title: '跟进记录新增' },
      component: require('@/views/gucangSales/followUpManage/followUpRecord/add/index.vue').default
    },
    {
      path: 'followUpRecord/edit',
      name: 'DcCosFbuFollowUpRecordEdit',
      meta: { title: '跟进记录编辑' },
      component: require('@/views/gucangSales/followUpManage/followUpRecord/edit/index.vue').default
    },
    {
      path: 'followUpRecord/view',
      name: 'DcCosFbuFollowUpRecordView',
      meta: { title: '跟进记录详情', noCache: true },
      component: require('@/views/gucangSales/followUpManage/followUpRecord/view/index.vue').default
    },
    {
      path: 'followUpRecord/commit',
      name: 'DcCosFbuFollowUpRecordCommit',
      meta: { title: '跟进记录评论' },
      component: require('@/views/gucangSales/followUpManage/followUpRecord/commit/index.vue').default
    },
    {
      path: 'followUpRecord/visitingPlan',
      name: 'DcCosFbuFollowUpRecordVisitingPlan',
      meta: { title: '完成拜访' },
      component: require('@/views/gucangSales/followUpManage/followUpRecord/followVisitingPlan/index.vue').default
    },
    {
      path: 'businessRuleSetting/customerCodeRating',
      name: 'DcCosFbuCustomerCodeRating',
      meta: { title: '客户代码评分' },
      component: require('@/views/gucangSales/businessRuleSetting/customerCodeRating/index.vue').default
    },
    {
      path: 'businessRuleSetting/ratingRules',
      name: 'DcCosFbuRatingRules',
      meta: { title: '评级规则' },
      component: require('@/views/gucangSales/businessRuleSetting/ratingRules/index.vue').default
    },
    {
      path: 'businessRuleSetting/transactionCustomerEquivalentStatus',
      name: 'DcCosFbuTransactionCustomerEquivalentStatus',
      meta: { title: '成交客户当量状态' },
      component: require('@/views/gucangSales/businessRuleSetting/transactionCustomerEquivalentStatus/index.vue')
        .default
    },
    {
      path: 'followRuleSetting',
      name: 'DcCosFbuFollowRuleSetting',
      meta: { title: '跟进规则设置' },
      component: require('@/views/gucangSales/followRuleSetting/index.vue').default
    },
    {
      path: 'businessRuleSetting/volumeOfBusinessLevel',
      name: 'DcCosFbuVolumeOfBusinessLevel',
      meta: { title: '成交额档次' },
      component: require('@/views/gucangSales/businessRuleSetting/ratingRules/index.vue').default
    },
    {
      path: 'businessRuleSetting/lossWarning',
      name: 'DcCosFbuLossWarning',
      meta: { title: '流失预警' },
      component: require('@/views/gucangSales/businessRuleSetting/lossWarning/index.vue').default
    },
    {
      path: 'businessRuleSetting/transactionVolume',
      name: 'DcCosFbuTransactionVolume',
      meta: { title: '成交额' },
      component: require('@/views/gucangSales/businessRuleSetting/transactionVolume/index.vue').default
    },
    {
      path: 'businessRuleSetting/customerChangeTask',
      name: 'DcCosFbuCustomerChangeTask',
      meta: { title: '客户转换任务' },
      component: require('@/views/gucangSales/businessRuleSetting/customerChangeTask/index.vue').default
    },
    {
      path: 'customerProcessing/lossCustomer',
      name: 'DcCosFbuLossCustomer',
      meta: { title: '流失客户/终止合作' },
      component: require('@/views/gucangSales/customerProcessing/lossCustomer/index.vue').default
    },
    {
      path: 'customerProcessing/blacklist',
      name: 'DcCosFbuBlacklist',
      meta: { title: '黑名单' },
      component: require('@/views/gucangSales/customerProcessing/blacklist/index.vue').default
    },
    {
      path: 'customerProcessing/cluesAudit',
      name: 'DcCosFbuCluesAudit',
      meta: { title: '线索审核' },
      component: require('@/views/gucangSales/customerProcessing/cluesAudit/index.vue').default
    },
    {
      path: 'administrativeRegion',
      name: 'DcCosFbuAdministrativeRegion',
      meta: { title: '行政区域' },
      component: require('@/views/gucangSales/administrativeRegion/index.vue').default
    },
    {
      path: 'registerLinksRecord',
      name: 'DcCosFbuRegisterLinksRecord',
      meta: { title: '注册链接发送记录' },
      component: require('@/views/gucangSales/registerLinksRecord/index.vue').default
    },
    {
      path: 'exportCenter/fbu',
      name: 'DcCosFbuExportCenter',
      meta: { title: '导出中心' },
      component: require('@/views/yuntuSales/exportCenter/index.vue').default
    },
    {
      path: 'gucangSales/example',
      name: 'DcCosFbuExample',
      meta: { title: 'Demo页' },
      component: require('@/views/example/index.vue').default
    },
    {
      path: 'infrastructure/serviceParamSetting',
      name: 'DcCosServiceParamSetting',
      meta: { title: '商机' },
      component: require('@/views/gucangSales/infrastructure/serviceParamSetting/index.vue').default
    },
    {
      path: 'baseSetting/areaCodeInformation',
      name: 'DcCosAreaCodeInformation',
      meta: { title: '区号信息' },
      component: require('@/views/gucangSales/baseSetting/areaCodeInformation/index.vue').default
    },
    {
      path: 'dataReport',
      name: 'DcCosFbuDataReport',
      meta: { title: '数据简报', noCache: true },
      component: require('@/views/gucangSales/marketLeads/dataReport/index.vue').default
    },
    {
      path: 'leadManage',
      name: 'DcCosFbuLeadManage',
      meta: { title: '市场线索管理' },
      component: require('@/views/gucangSales/marketLeads/leadManage/index.vue').default
    },
    {
      path: 'leadManage/add',
      name: 'DcCosFbuLeadManageAdd',
      meta: { title: '新增市场线索' },
      component: require('@/views/gucangSales/marketLeads/leadManage/add/index.vue').default
    },
    {
      path: 'leadManage/edit',
      name: 'DcCosFbuLeadManageEdit',
      meta: { title: '编辑市场线索' },
      component: require('@/views/gucangSales/marketLeads/leadManage/edit/index.vue').default
    },
    {
      path: 'leadManage/view',
      name: 'DcCosFbuLeadManageView',
      meta: { title: '市场线索详情', noCache: true },
      component: require('@/views/gucangSales/marketLeads/leadManage/view/index.vue').default
    },
    {
      path: 'deliveryRecord',
      name: 'DcCosFbuDeliveryRecord',
      meta: { title: '投放记录' },
      component: require('@/views/gucangSales/marketLeads/deliveryRecord/index.vue').default
    },
    {
      path: 'tagsManage',
      name: 'DcCosFbuTagManage',
      meta: { title: '标签管理' },
      component: require('@/views/gucangSales/marketing/tagManage/index.vue').default
    },
    {
      path: 'tagsManage/add',
      name: 'DcCosFbuTagManageAdd',
      meta: { title: '新增标签' },
      component: require('@/views/gucangSales/marketing/tagManage/add.vue').default
    },
    {
      path: 'tagsManage/edit',
      name: 'DcCosFbuTagManageEdit',
      meta: { title: '编辑标签' },
      component: require('@/views/gucangSales/marketing/tagManage/edit.vue').default
    },
    {
      path: 'tagsManage/view',
      name: 'DcCosFbuTagManageView',
      meta: { title: '标签详情', noCache: true },
      component: require('@/views/gucangSales/marketing/tagManage/view.vue').default
    },
    {
      path: 'partnerManage',
      name: 'DcCosFbuPartnerManage',
      meta: { title: '合作伙伴管理' },
      component: require('@/views/gucangSales/marketing/partnerManage/index.vue').default
    },
    {
      path: 'partnerManage/view',
      name: 'DcCosFbuPartnerManageView',
      meta: { title: '合作伙伴详情', noCache: true },
      component: require('@/views/gucangSales/marketing/partnerManage/view/index.vue').default
    },
    {
      path: 'partnerManage/add',
      name: 'DcCosFbuPartnerManageAdd',
      meta: { title: '新增合作伙伴' },
      component: require('@/views/gucangSales/marketing/partnerManage/add/index.vue').default
    },
    {
      path: 'partnerManage/edit',
      name: 'DcCosFbuPartnerManageEdit',
      meta: { title: '编辑合作伙伴' },
      component: require('@/views/gucangSales/marketing/partnerManage/edit/index.vue').default
    },
    {
      path: 'activityCode',
      name: 'DcCosFbuActivityCode',
      meta: { title: '活码管理' },
      component: require('@/views/gucangSales/marketing/activityCode/index.vue').default
    },
    {
      path: 'activityCode/add',
      name: 'DcCosFbuActivityCodeAdd',
      meta: { title: '新增活码' },
      component: require('@/views/gucangSales/marketing/activityCode/add.vue').default
    },
    {
      path: 'activityCode/edit',
      name: 'DcCosFbuActivityCodeEdit',
      meta: { title: '编辑活码' },
      component: require('@/views/gucangSales/marketing/activityCode/edit.vue').default
    },
    {
      path: 'activityCode/view',
      name: 'DcCosFbuActivityCodeView',
      meta: { title: '活码详情', noCache: true },
      component: require('@/views/gucangSales/marketing/activityCode/view.vue').default
    },
    {
      path: 'templateManage',
      name: 'DcCosFbuTemplateManage',
      meta: { title: '模版管理' },
      component: require('@/views/gucangSales/marketing/templateManage/index.vue').default
    },
    {
      path: 'cardManage',
      name: 'DcCosFbuCardManage',
      meta: { title: '名片管理' },
      component: require('@/views/gucangSales/marketing/cardManage/index.vue').default
    },
    {
      path: 'interfaceRecord',
      name: 'DcCosFbuInterfaceRecord',
      meta: { title: '接口记录' },
      component: require('@/views/gucangSales/marketing/interfaceRecord/index.vue').default
    },
    {
      path: 'clueReceive',
      name: 'DcCosFbuClueReceive',
      meta: { title: '线索接收设置' },
      component: require('@/views/gucangSales/marketing/clueReceive/index.vue').default
    },
    {
      path: 'marketingExport',
      name: 'DcCosFbuMarketingExport',
      meta: { title: '导出中心' },
      component: require('@/views/yuntuSales/exportCenter/index.vue').default
    },
    {
      path: 'followChangeFeedback',
      name: 'DcCosFbuFollowChangeFeedback',
      meta: { title: '异动反馈情况' },
      component: require('@/views/gucangSales/analysis/followChangeFeedback/index.vue').default
    },
    {
      path: 'visitToSign',
      name: 'DcCosFbuVisitToSign',
      meta: { title: '拜访签到' },
      component: require('@/views/gucangSales/visitToSign/index.vue').default
    },
    {
      path: 'visitToSignDetail',
      name: 'DcCosFbuVisitToSignDetail',
      meta: { title: '拜访签到详情' },
      component: require('@/views/gucangSales/visitToSign/detail.vue').default
    },
    {
      path: 'publicCustomer',
      name: 'DcCosFbuPublicCustomer',
      meta: { title: '客户公海池' },
      component: require('@/views/gucangSales/customerCenter/publicCustomer/index.vue').default
    },
    {
      path: 'dataBoard',
      name: 'DcCosFbuDataBoard',
      meta: { title: '数据看板(销售)' },
      component: require('@/views/gucangSales/dataBoard/index.vue').default
    },
    {
      path: 'dataBoard/region',
      name: 'DcCosFbuDataBoardRegion',
      meta: { title: '数据看板(区域)' },
      component: require('@/views/gucangSales/dataBoard/region/index.vue').default
    },
    {
      path: 'customerProcessing/regionSetting',
      name: 'DcCosFbuRegionSetting',
      meta: { title: '区域员工设置' },
      component: require('@/views/gucangSales/customerProcessing/regionSetting/index.vue').default
    }
  ]
}

export default routerItem
